export const pay_setting_btn_link={
    paypal: "/international-payment/paypal",
    paypal_personal: "/international-payment/paypal_personal",
    stripe: "/international-payment/stripe",
    paddle: "/international-payment/paddle",
    perfect_money: "/international-payment/perfectMoney",
    manual: "/manage-international-method",
}